import * as ReactService from "@intech/react-service";
import { FichaFinanceiraAssistidoEntidade } from "../entidades/FichaFinanceiraAssistidoEntidade";

class FichaFinanceiraAssistido extends ReactService.BaseService {
  constructor() {
    super("FichaFinanceiraAssistido");
  }

  BuscarUltimaPorPlanoProcesso = (cdPlano: string, cdEspecie: string, anoProcesso: string, numProcesso: string) =>
    this.CreateRequest<FichaFinanceiraAssistidoEntidade[]>(ReactService.RequestType.GET, `BuscarUltimaPorPlanoProcesso/${cdPlano}/${cdEspecie}/${anoProcesso}/${numProcesso}`);

  BuscarDatas = (cdPlano: string) =>
    this.CreateRequest<FichaFinanceiraAssistidoEntidade[]>(ReactService.RequestType.GET, `BuscarDatas/${cdPlano}`);

  BuscarPorDataReferencia = (cdPlano: string, referencia: string, cdTipoFolha: string, cdEspecie: string) =>
    this.CreateRequest<any>(ReactService.RequestType.GET, `BuscarPorDataReferencia/${cdPlano}/${referencia}/${cdTipoFolha}/${cdEspecie}`);

  BuscarPorDataReferenciaIncidLiquidoN = (cdPlano: string, referencia: string, cdTipoFolha: string, cdEspecie: string) =>
    this.CreateRequest<FichaFinanceiraAssistidoEntidade[]>(ReactService.RequestType.GET, `BuscarPorDataReferenciaIncidLiquidoN/${cdPlano}/${referencia}/${cdTipoFolha}/${cdEspecie}`);

  GetRelatorio = (cdPlano: string, referencia: string, cdTipoFolha: string, cdEspecie: string, enviarPorEmail: boolean) =>
    this.CreateRequest<any>(ReactService.RequestType.GET, `relatorio/${cdPlano}/${referencia}/${cdTipoFolha}/${cdEspecie}/${enviarPorEmail}`, null, ReactService.ResponseType.Blob);

}

export const FichaFinanceiraAssistidoService = new FichaFinanceiraAssistido();
